import React from 'react';

const ImagePrefixer = ({ imgSrc, children }) => {
	return (
		<div>
			<img style={{ maxWidth: '90px' }} src={imgSrc} alt="" loading="lazy" />
			{children}
		</div>
	);
};

export default ImagePrefixer;
